import { render, staticRenderFns } from "./POSOrderViewer.vue?vue&type=template&id=888fa54e&scoped=true&"
import script from "./POSOrderViewer.vue?vue&type=script&lang=js&"
export * from "./POSOrderViewer.vue?vue&type=script&lang=js&"
import style0 from "./POSOrderViewer.vue?vue&type=style&index=0&id=888fa54e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "888fa54e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VDivider,VIcon,VSimpleTable,VTextField,VTextarea})
